const TrendingGames =  (id, subgroup) => {
	fetch("/sections/SiteController.php?games=trendinggame&subgroup="+subgroup)
	.then(function(response) {
	if (response.ok) {
		return response.text();
	} else {
		throw new Error("Error occurred while fetching the game.");
	}
	})
	.then(function(responseText) {
		var targetDiv = document.getElementById(id);
		targetDiv.innerHTML = responseText;
	})
	.catch(function(error) {
		console.log(error);
	});
}

const NewGames = (id) => {
	fetch("/sections/SiteController.php?games=newgames")
	.then(function(response) {
	if (response.ok) {
		return response.text();
	} else {
		throw new Error("Error occurred while fetching the game.");
	}
	})
	.then(function(responseText) {
		var targetDiv = document.getElementById(id);
		targetDiv.innerHTML = responseText;
	})
	.catch(function(error) {
		console.log(error);
	});
}

const jackpotgames = (id) => {
	fetch("/sections/SiteController.php?games=jackpotgames")
	.then(function(response) {
	if (response.ok) {
		return response.text();
	} else {
		throw new Error("Error occurred while fetching the game.");
	}
	})
	.then(function(responseText) {
		var targetDiv = document.getElementById(id);
		targetDiv.innerHTML = responseText;
	})
	.catch(function(error) {
		console.log(error);
	});
}

const gettournamnets = (tounamentlink = '') => {
	var linkTags = '';
	if(tounamentlink !== ""){
		linkTags = `<a class="btn buy-in" href="javascript:void('')" onclick="triggerLogin({custom_redirect:'/tournaments-lobby.php', tourRedirect:'${tounamentlink}' })">`;
	}else{
		linkTags = `<a class="btn buy-in" href="/tournaments-lobby.php">`;
	}
	const tab3 = document.getElementById('toursectiontab');
  
	fetch('/app/shared/controllers/TournamentsController.php?upcoming')
	//fetch('/sections/test.php')
	.then((response) => response.json())
	.then((tournamentsList) => {
		var tournamentsCount = tournamentsList.length;
		//console.log(tournamentsCount);
		if(tournamentsCount > 0) {
		
		var i = 0;
		var html = ''; // define html variable before the forEach loop
		var classHide = '';
		var classSliderCount = 'slidercount' + tournamentsCount;
		if(tournamentsCount < 3) {
			classHide = 'btnHide';
		}
		
		// use Promise.all() to wait for all the fetch() requests to complete
		Promise.all(tournamentsList.map((tournament, index) => {

			if (i < 3) { // check if the counter is less than 3
			return fetch('/sections/SiteController.php?games=singlegames&gameid=' + tournament.game_id + '&machineid=' + tournament.mach_id)
				.then((response) => response.json())
				.then((image) => {
				
				if(image.simple_name != ""){

					const startDate = new Date(tournament.tournament_start_date);
					const options = { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' };
					const formatter = new Intl.DateTimeFormat('en-GB', options);
					const tournament_start_date = `${startDate.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit' })} - ${startDate.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`;

					
					const endDate = new Date(tournament.tournament_end_date);
					const tournament_end_date = `${endDate.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit' })} - ${endDate.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`;
					const tournament_end_date11 = `${endDate.toLocaleDateString('en-CA')}`;
					//console.log(tournament_end_date11);
					
					
					const startTime = startDate.toLocaleDateString('en-GB');
					const endTime = endDate.toLocaleDateString('en-GB');
					
/* 					console.log('-----',tournament_start_date);
					console.log(tournament_end_date);
					console.log(startTime);
					console.log(endTime); */
					var CurrentDate = new Date();
					GivenDate = new Date(tournament_end_date11);
					//console.log(GivenDate+'givendate');
					
					
					
					var CurrentDate = new Date();
					if(GivenDate > CurrentDate){
						var tournment_class = '';
						var tournment_status = 'COMING SOON';
					}else{
						var tournment_status = 'LIVE';
						var tournment_class = 'live';
					} 

					//var imageUrl = ASSETSDOMAINJS + '/rtg/hero/' + image.simple_name+ '.gif';
					function checkIfImageExists(url, callback) {
					const img = new Image();
					img.src = url;
					
					if (img.complete) {
						callback(true);
					} else {
						img.onload = () => {
						callback(true);
						};
						
						img.onerror = () => {
						callback(false);
						};
					}
					}
					
					var imageUrl = ASSETSDOMAINJS + '/rtg/screen/cash-bandits-museum-heist.png';
					// USAGE
					checkIfImageExists(ASSETSDOMAINJS + '/rtg/screen/' + image.simple_name+ '.png', (exists) => {
					if (exists) {
						// console.log('image');
						var imageUrl = ASSETSDOMAINJS + '/rtg/screen/' + image.simple_name+ '.png';
					} 
					});
					
					html += '<div class="swiper-slide"><div class="timer-section"><h2>Tournaments</h2><div class="timer-inner"><div><span style="min-width:85px;" class="coming-soon '+tournment_class+'">'+tournment_status+'</span><h4>' + tournament.tournament_name + '</h4><p>Start: <span class="timer-red">' + tournament_start_date + '</span>- End: <span class="timer-blue">' + tournament_end_date + '</span> </p><p class="price">Prize Pool: <span> R'+ tournament.prize_pool+'</span></p><div  id="countdown" class="timer-element" data-time="'+endDate+'" data-start="'+startDate+'" data-status="'+tournament.status+'"><span></span><div class="content-timer--date-hour"></div><span>: </span><div class="content-timer--date-hour"></div></div>'+linkTags+'Buy-In</a></div></div></div><div class="tournament-img"><picture><source media="(min-width: 1025px)" srcset="' + imageUrl + '"><img alt="' + imageUrl + '" src="' + imageUrl + '" /> </picture> </div></div>';
				}
				})
				.catch((error) => {
					console.log(error);
				});
			i++;
			}
			else {
				return Promise.resolve(); // return a resolved promise when the counter reaches 3
			}
		}))
		.then(() => {
			
			var tournamentsHtml = '<div class="tournaments-container container"><div class="swiper tournaments"><div class="swiper-wrapper">' + html + '</div><div class="swiper-button-next swiper-button-next3"><i class="bi bi-arrow-right-short"></i></div><div class="swiper-button-prev swiper-button-prev3"><i class="bi bi-arrow-left-short"></i></div></div></div>';

			document.getElementById('tournamentdatadetail').innerHTML  = tournamentsHtml;
			var swipers = new Swiper(".tournaments", {
				loop: true,
				navigation: {
				  nextEl: ".swiper-button-next3",
				  prevEl: ".swiper-button-prev3",
				},
			  });
			  //you can add code here tournament

			const cardtimer = document.querySelectorAll(".timer-element");

			if (cardtimer) {
			for (const item of cardtimer) {
				const date = item.getAttribute("data-time");
				const start = item.getAttribute("data-start");
				const status = item.getAttribute("data-status");
				if(status === 'archived')
				break
				createCardTimer(item, date, start, status);
			}
			}
			  
  
		});
		}else{
		document.getElementById('tournamentdatadetail').style.display = 'none';

		}
	});
}

const WinnersData = (id) => {
	fetch("/sections/SiteController.php?section=getwinners")
	.then(function(response) {
	if (response.ok) {
		return response.text();
	} else {
		throw new Error("Error occurred while fetching the winners.");
	}
	})
	.then(function(responseText) {
		var targetDiv = document.getElementById(id);
		targetDiv.innerHTML = responseText;
	})
	.catch(function(error) {
		console.log(error);
	});
}

document.addEventListener("DOMContentLoaded", function() {
	// TrendingGames
	if(document.getElementById('hometemplate')){
		TrendingGames('trendinggames_mostplayed', 'Prism - Most Played');
		TrendingGames('trendinggames_topplaying', 'Prism - Top Paying');
		TrendingGames('trendinggames_bestrtp', 'Prism - Best RTP');
		NewGames('newgames');
		jackpotgames('jackpotgames');
		TrendingGames('trendinggames_allGames', 'allgames');
		gettournamnets('link');
		WinnersData('getwinners');
	}
});

function createCardTimer(element, date, start, status) {
	var countDownDate = new Date(date).getTime();
	var startDown = new Date(start).getTime();
  
	updateClock();
  
	function updateClock() {
	  let lang = document.documentElement.lang;
	  let d = 'DAY';
	  let h = 'HOUR';
	  let m = 'MIN';
	  let s = 'SEC';
  
	  var now = new Date().getTime();
	  var distance = (status === 'upcoming') ? startDown - now : countDownDate - now;
  
	  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
	  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	  //var hours = hours - 6;
	  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
	  var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
	  if (hours < 10) {
		hours = "0" + hours;
	  }
  
	  if (minutes < 10) {
		minutes = "0" + minutes;
	  }
  
	  element.innerHTML = `
		<ul>
		  <li> <span>${days}</span>
			<div class='content-timer--date-hour'> ${d}</div>
		  </li>
		  <li>
			<span id="hours">${hours}</span>
			<div class='content-timer--date-hour'> ${h}</div>
		  </li>
		  <li>
			<span id="minutes"> ${minutes} </span>
			<div class='content-timer--date-hour'> ${m}</div>
		  </li>
		  <li>
			<span> ${seconds} </span>
			<div class='content-timer--date-hour'> ${s}</div>
		  </li>
		</ul>
	  `;
  
	  if (distance <= 0) {
		clearInterval(x);
		element.innerHTML = "";
	  }
	}
  
	var x = setInterval(function () {
	  updateClock();
	}, 1000);
  }